function ListNumberedIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <line x1="9" y1="6" x2="20" y2="6" />
      <line x1="9" y1="12" x2="20" y2="12" />
      <line x1="9" y1="18" x2="20" y2="18" />
      <text x="1" y="8.5" fontSize="6.5" fontWeight={700} fontFamily="ui-sans-serif, system-ui, sans-serif" fill="currentColor" stroke="none">1.</text>
      <text x="1" y="14.5" fontSize="6.5" fontWeight={700} fontFamily="ui-sans-serif, system-ui, sans-serif" fill="currentColor" stroke="none">2.</text>
      <text x="1" y="20.5" fontSize="6.5" fontWeight={700} fontFamily="ui-sans-serif, system-ui, sans-serif" fill="currentColor" stroke="none">3.</text>
    </svg>
  );
}

export default ListNumberedIcon;
